module.exports = __webpack_public_path__ + "static/img/trrafic-food-icon.b70a2c06.svg";